import { render } from "./Button.vue?vue&type=template&id=39c72883&ts=true&lang=pug"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\UiDesk\\laragon-5.0.0\\www\\click-to-call\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__